module.exports = __webpack_public_path__ + "static/img/3-03.6051548.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/3-03.png
// module id = 230
// module chunks = 0